// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ModuleType,
  DeploymentStatus,
} from "./types";


export default __t.row({
  id: __t.u32().primaryKey(),
  projectId: __t.u32().name("project_id"),
  get moduleType() {
    return ModuleType.name("module_type");
  },
  databaseName: __t.string().name("database_name"),
  get status() {
    return DeploymentStatus;
  },
  wasmHash: __t.option(__t.string()).name("wasm_hash"),
  errorMessage: __t.option(__t.string()).name("error_message"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
  deployedBy: __t.identity().name("deployed_by"),
});
